module.exports = __webpack_public_path__ + "img/sh-logo.9b3d0021.svg";